export enum MenuCheckboxItemDataAttributes {
  /**
   * Present when the menu checkbox item is checked.
   */
  checked = 'data-checked',
  /**
   * Present when the menu checkbox item is not checked.
   */
  unchecked = 'data-unchecked',
  /**
   * Present when the menu checkbox item is disabled.
   */
  disabled = 'data-disabled',
  /**
   * Present when the menu checkbox item is highlighted.
   */
  highlighted = 'data-highlighted',
}
